export default __webpack_public_path__ + "static/media/logo_abla.c839bb9b.svg";